<template>
  <div id="watermark" v-if="isready">
    <div>{{displayinfo}} / {{serverinfos}}</div>
  </div>
</template>

<script>
import { AppSettings } from '@/appmodules/appsettings'
export default {
  name: 'watermark',
  props: {},
  computed: {
    displayinfo() {
      return 'env : ' + process.env.NODE_ENV
    }
  },
  data: function() {
    return {
      isready: false,
      serverinfos: ''
    }
  },
  mounted() {},
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData()
  },
  methods: {
    async fetchData() {
      if (process.env.NODE_ENV != 'production') {
        this.isready = true
        const resp = await fetch(
          new AppSettings().apiBasePath() + '/api/resources/backendinfo'
        )
        if (resp.ok) this.serverinfos = await resp.text()
      }
    }
  }
}
</script>

<style lang="less">
#watermark {
  margin-top: 10%;
  text-align: left;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Watermark.vue